import type { ErrorType } from '~/data/ErrorRecord';

export const defaultState: Fields = {
  isLoading: false,
  downloadUrl: undefined,
  error: undefined,
  downloadUrlError: undefined,
};

export interface Fields {
  isLoading: boolean;
  downloadUrl: string | undefined;
  error?: ErrorType;
  downloadUrlError?: ErrorType;
}
